var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',{attrs:{"value":_vm.active}},[_c('vs-tab',{attrs:{"label":"Draft"}},[_c('Draft')],1),_c('vs-tab',{attrs:{"label":"Complete"}},[_c('Complete')],1),_c('vs-tab',{attrs:{"label":"Cancel"}},[_c('Cancel')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }